export default function NotFoundPage({ onNavigate }) {
  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '120px 24px 80px', textAlign: 'center' }}>
      <div>
        <div style={{ fontSize: '6rem', fontWeight: 800, color: 'var(--off-2)', lineHeight: 1 }}>404</div>
        <h2 style={{ marginTop: 16 }}>Page not found</h2>
        <p style={{ marginBottom: 28 }}>The page you're looking for doesn't exist.</p>
        <button className="btn primary" onClick={() => onNavigate('/')}>Back to home</button>
      </div>
    </div>
  );
}
